/**
 * The account the board is showing, handed to every widget on it.
 *
 * Widgets need the same `selectedDepartment` the tabs get, and nothing else —
 * each panel already owns its own queries. Keeping that in context rather than
 * prop-drilling is what lets `TEKSTAK_WIDGETS` be a flat type → component map
 * instead of a map of factories.
 */

import React, { createContext, useContext } from 'react';

const BoardAccountContext = createContext(null);

export function BoardAccountProvider({ value, children }) {
  return <BoardAccountContext.Provider value={value}>{children}</BoardAccountContext.Provider>;
}

/**
 * Returns an empty shape rather than throwing when a widget is somehow
 * rendered outside the provider — a misplaced widget should render an empty
 * card, not white-screen the account page.
 */
export function useBoardAccount() {
  return useContext(BoardAccountContext) || {
    selectedDepartment: null,
    departments: [],
    deptKey: null,
  };
}

export default BoardAccountContext;
